import A11yMenu from './_a11yMenu';
import TabsManual from './_tabsManual';
import GLightbox from 'glightbox';
import Swiper from 'swiper';
import {
	Navigation, Pagination, A11y,
} from 'swiper/modules';

import {
	OverlayScrollbars,
	ScrollbarsHidingPlugin,
	ClickScrollPlugin,
	SizeObserverPlugin,
} from 'overlayscrollbars';

const initScrollbars = () => {
	const scrolls = document.querySelectorAll('.js-scrollbar');
	if (scrolls) {
		OverlayScrollbars.plugin([SizeObserverPlugin, ScrollbarsHidingPlugin, ClickScrollPlugin]);
		scrolls.forEach((elt) => {
			OverlayScrollbars(elt, {
				overflow: {
					y: 'hidden',
				},
				scrollbars: {
					theme: 'os-theme-dark',
					visibility: 'auto',
					clickScroll: true,
				},
			}, {
				updated(osInstance) {
					// For accessibility

					const scrollableDiv = osInstance.elements().content;
					if (osInstance.state().hasOverflow.x) {
						scrollableDiv.setAttribute('tabindex', 0);
						scrollableDiv.setAttribute('role', 'region');
						scrollableDiv.setAttribute('aria-label', 'Contenu avec scroll');
					} else {
						scrollableDiv.setAttribute('tabindex', -1);
						scrollableDiv.removeAttribute('role');
						scrollableDiv.removeAttribute('aria-label');
					}
				},
			});
		});
	}
};

const initMultiBlocksSlider = () => {
	const sliders = document.querySelectorAll('.multiblocks-swiper');
	sliders.forEach((elt) => {
		const nbCols = elt.getAttribute('data-tabCols');
		const swiper = new Swiper(elt, {
			modules: [Pagination, A11y],
			slidesPerView: 1,
			spaceBetween: 36,
			enabled: true,
			autoHeight: true,
			init: false,
			watchOverflow: false,
			a11y: {
				enabled: true,
				containerRoleDescriptionMessage: 'carousel',
				itemRoleDescriptionMessage: 'slide',
			},
			pagination: {
				el: elt.querySelector('.swiper-pagination'),
				clickable: true,
				bulletElement: 'button',
			},
			breakpoints: {
				640: {
					slidesPerView: 2,
					enabled: true,
				},
				720: {
					slidesPerView: nbCols,
					enabled: true,
				},
				960: {
					enabled: false,
				},
			},
		});

		swiper.on('breakpoint', (swipe, breakpointParams) => {
			if (!breakpointParams.enabled) {
				swipe.el.classList.add('disabled');
			} else {
				swipe.el.classList.remove('disabled');
			}
		});
		swiper.init();
	});
};

const initFormationSlider = () => {
	const sliders = document.querySelectorAll('.formations-swiper');
	sliders.forEach((elt) => {
		const swiper = new Swiper(elt, {
			modules: [Navigation, Pagination, A11y],
			slidesPerView: 1,
			spaceBetween: 36,
			init: false,
			autoHeight: false,
			centerInsufficientSlides: true,
			a11y: {
				enabled: true,
				containerRoleDescriptionMessage: 'carousel',
				itemRoleDescriptionMessage: 'slide',
				prevSlideMessage: 'élément suivant',
				nextSlideMessage: 'élément précédent',
			},
			pagination: {
				el: '.swp-pagination',
				clickable: true,
				bulletElement: 'button',
			},
			navigation: {
				nextEl: elt.querySelector('.swp-button-next'),
				prevEl: elt.querySelector('.swp-button-prev'),
				clickable: true,
			},
			breakpoints: {
				800: {
					slidesPerView: 2,
				},
				1280: {
					slidesPerView: 3,
				},
			},
		});
		swiper.init();
	});
};

const initTestimonialSlider = () => {
	const sliders = document.querySelectorAll('.testimonials-swiper');
	sliders.forEach((elt) => {
		const swiper = new Swiper(elt, {
			modules: [A11y],
			slidesPerView: 1,
			centeredSlides: false,
			spaceBetween: 36,
			init: false,
			autoHeight: false,
			grabCursor: true,
			a11y: {
				enabled: true,
				containerRoleDescriptionMessage: 'carousel',
				itemRoleDescriptionMessage: 'slide',
				scrollOnFocus: true,
				wrapperLiveRegion: false,
			},
			breakpoints: {
				640: {
					slidesPerView: 2,
				},
				800: {
					slidesPerView: 'auto',
					centeredSlides: true,
					centerInsufficientSlides: true,
					centeredSlidesBounds: true,
				},
			},
		});
		swiper.init();
	});
};

const init3ColSlider = () => {
	const sliders = document.querySelectorAll('.col-3-swiper');
	sliders.forEach((elt) => {
		const swiper = new Swiper(elt, {
			modules: [Navigation, Pagination, A11y],
			slidesPerView: 1,
			spaceBetween: 24,
			init: false,
			autoHeight: false,
			a11y: {
				enabled: true,
				containerRoleDescriptionMessage: 'carousel',
				itemRoleDescriptionMessage: 'slide',
				scrollOnFocus: true,
				wrapperLiveRegion: false,
			},
			pagination: {
				el: '.swp-pagination',
				clickable: true,
				bulletElement: 'button',
			},
			navigation: {
				nextEl: elt.querySelector('.swp-button-next'),
				prevEl: elt.querySelector('.swp-button-prev'),
				clickable: true,
			},
			breakpoints: {
				640: {
					slidesPerView: 2,
				},
				800: {
					slidesPerView: 'auto',
				},
			},
		});
		swiper.init();
	});
};

const initGalSlider = () => {
	const sliders = document.querySelectorAll('.swiper-gal');
	sliders.forEach((elt) => {
		const swiper = new Swiper(elt, {
			modules: [Navigation, Pagination, A11y],
			slidesPerView: 1,
			spaceBetween: 24,
			init: false,
			a11y: {
				enabled: true,
				containerRoleDescriptionMessage: 'carousel',
				itemRoleDescriptionMessage: 'slide',
				scrollOnFocus: true,
				wrapperLiveRegion: true,
			},
			pagination: {
				el: '.swp-pagination',
				clickable: true,
				bulletElement: 'button',
			},
			navigation: {
				nextEl: elt.querySelector('.swp-button-next'),
				prevEl: elt.querySelector('.swp-button-prev'),
				clickable: true,
			},
		});
		swiper.init();
	});
};

const initTabLists = () => {
	// TABS LISTS
	const tablists = document.querySelectorAll('.tablist[role=tablist]');
	tablists.forEach((tab) => {
		new TabsManual(tab).init();
	});
};

const handlePopover = function handlePopover(button, popover) {
	const closeButton = popover.querySelector('#close_popover');
	closeButton.addEventListener('click', () => {
		popover.hidePopover();
		button.focus();
	});

	button.addEventListener('click', () => {
		popover.showPopover();
		popover.focus();
	});

	button.addEventListener('keydown', (e) => {
		// enter key
		if (e.keyCode === 13) {
			popover.showPopover();
			popover.focus();
		}

		if (e.keyCode === 32) {
			e.preventDefault();
		}
	});

	button.addEventListener('keyup', (e) => {
		// space key
		if (e.keyCode === 32) {
			popover.showPopover();
			popover.focus();
		}
	});
};

document.addEventListener('DOMContentLoaded', () => {
	// Solve menu animation firing on page load
	const trItem = document.querySelector('.preload-animation');
	if (trItem) {
		window.setTimeout(() => {
			trItem.classList.remove('preload-animation');
		}, 640);
	}

	const menu = new A11yMenu(document.querySelector('.a11y-nav-block'), '70rem');
	menu.menuSetup();

	initMultiBlocksSlider();
	initFormationSlider();
	initTestimonialSlider();
	init3ColSlider();
	initGalSlider();

	initScrollbars();

	initTabLists();

	const displayMore = document.querySelectorAll('.js-display-more');
	displayMore.forEach((elt) => {
		const toDeployWrapper = elt.parentElement.querySelector('.disclosure-bio');
		const toShow = toDeployWrapper?.querySelector('p[hidden]');
		const buttonText = elt.querySelector('span');

		elt.addEventListener('click', () => {
			if (toShow.hasAttribute('hidden')) {
				toShow.removeAttribute('hidden');
				toDeployWrapper.focus();
				buttonText.innerText = 'Afficher moins';
			} else {
				toShow.setAttribute('hidden', '');
				buttonText.innerText = 'Afficher plus';
			}
		});
	});

	const lightbox = GLightbox({
		touchNavigation: true,
		loop: true,
	});

	const openPopin = document.querySelectorAll('#openPopin');
	openPopin.forEach((div) => {
		const popover = div.parentElement.parentElement.querySelector('#popover_resa');
		const button = div.querySelector('button');

		handlePopover(button, popover);
	});
});
